import { Controller } from '@hotwired/stimulus';
import ahoy from 'ahoy.js';

/* USAGE:
    1. Put a data-controller around the elements you want to track
      (to work on all user side use it on the <body> on 'views/layouts/application.html.erb')
    2. For each element:
      - add a data-action with analytics#track function
      - set track params : name and properties

    - Around
    data: { controller: 'analytics' }

    - Element
    data: {
      action: '{action}->analytics#track',
      'analytics-name-param': 'QR Code Link',
      'analytics-properties-param': { qr_code_id: id_do_qrcode, qr_code_link_id: id_do_qrcode_link, link: url_do_link_que_foi_clicado }
    }

  CHECK TRACK:
    1. Go to localhost:3000/blazer
    2. New query
    3. Change the selector from 'preview table' to 'ahoy events' (make sure you delete the 'LIMIT 10' on the console on the top of the page) and click the 'run' button
      or
       Type 'SELECT * FROM "ahoy_events" ORDER BY time DESC' on the console on the top of the page and click the 'run' button to see the events ordered by the last to the first
*/

export default class extends Controller {
  connect() {
  }

  track(event) {
    ahoy.track(event.params.name + ' — ' + event.type, event.params.properties);
  }
}
